import type { FaireProductEntity } from "../../entity_types/product";

export const p_aacjg3s7a2: FaireProductEntity = {
  token: "p_aacjg3s7a2",
  type: "product",
  name: "Ceramic Vase, 8-Ball",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/c3ebef62c7952d27c79be6c7e74797415a0a14d05a126d773569415ce28bce85.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f952d76048f9ad4059933f2a13d02515bbb2566160fd2bde325f35aa6e187136.jpeg",
    "https://cdn.faire.com/fastly/ab0e03178ed587d77f980b1c317128c8e6b4208cad7680f975efdb48eb37da0b.jpeg"
  ],
  priceDollars: 13,
  description: "We see a lil’ bouquet of flowers in your future. And they’ll look extra good in this ceramic 8-ball vase. Made from high-quality ceramic, this Bando vase adds a touch of retro fun and mystery to any space. Oh, and psst… there’s a secret fortune hidden inside — because we like our décor with a little surprise and a lot of personality.\n\n**Features:**\n\n• Made of durable, glossy ceramic\n• 8-ball–inspired design with a playful twist\n• Includes a hidden fortune inside for extra fun\n• Perfect for flowers, dried stems, or desk accessories\n• Adds a retro-meets-modern pop to any room\n\n**Ideal For:**\n\n• Gift shops and home décor boutiques\n• Lifestyle retailers and floral studios\n• Novelty gift collections or pop culture displays\n• Wholesale buyers seeking unique, collectible ceramics",
  tags: [],
  msrpDollars: 26.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:41.721Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
